import { windowUtils } from '@packages/domain/utils/windowUtils/windowUtils';
import { HEAP_ENVS } from 'constants/heap';
import { Heap } from './Heap/Heap';

function AnalyticsHeap() {
  const shouldInitHeap = HEAP_ENVS.includes(windowUtils.getHostname());
  if (shouldInitHeap) {
    Heap.initialize();
  }
  return null;
}

export { AnalyticsHeap };
